import { GenerationTypeFormStepContent } from '@/api/interfaces/content/form/steps/generationTypeFormStepContent';

export const generationTypeContent: GenerationTypeFormStepContent = {
    stepHeading: 'Erzeugungsart',
    buttonNext: {
        text: 'Weiter',
    },
    stepIntro: {
        text:
            'Bitte w&auml;hlen Sie zun&auml;chst die Energie- und Anlagenart aus.',
    },
    energyType: {
        label: 'Mit welcher Energieart wird Ihre Erzeugungsanlage betrieben?',
        summaryLabel: 'Energieart',
        placeholder: 'Bitte wählen',
        options: {
            energyStorage: {
                label: 'Energiespeicher',
            },
            sun: {
                label: 'Sonne',
            },
            sunAndEnergyStorageLte30: {
                label: 'Sonne + Energiespeicher bis 30 kW',
            },
            water: {
                label: 'Wasser',
            },
            wind: {
                label: 'Wind',
            },
            biogas: {
                label: 'Biogas',
            },
            biowaste: {
                label: 'Bioabfälle',
            },
            biodiesel: {
                label: 'Biodiesel',
            },
            slurry: {
                label: 'Gülle',
            },
            plantOil: {
                label: 'Pflanzenöl',
            },
            woodGas: {
                label: 'Holzgas',
            },
            mineGas: {
                label: 'Grubengas',
            },
            sewageGas: {
                label: 'Klärgas',
            },
            landfillGas: {
                label: 'Deponiegas',
            },
            geothermics: {
                label: 'Geothermie',
            },
            naturalGas: {
                label: 'Erdgas',
            },
            liquidGas: {
                label: 'Flüssiggas',
            },
            dieselOil: {
                label: 'Dieselöl',
            },
        },
    },
    plantType: {
        label: 'Um was f&uuml;r eine Anlagenart handelt es sich?',
        summaryLabel: 'Anlagenart',
        placeholder: 'Bitte wählen',
        options: {
            photovoltaicPowerPlant: {
                label: 'Solaranlage',
            },
            photovoltaicPowerPlantAndStorageLte30: {
                label: 'Solaranlage + Speicher bis 30 kW',
            },
            thermalPowerPlantKwk: {
                label: 'Blockheizkraftwerk',
            },
            windPowerPlant: {
                label: 'Windenergieanlage',
            },
            hydroPowerPlant: {
                label: 'Wasserkraftanlage',
            },
            steamTurbine: {
                label: 'Wasserdampfturbine',
            },
            thermalPowerPlantDea: {
                label: 'Blockheizkraftwerk',
            },
            gasTurbine: {
                label: 'Gasturbine',
            },
            fuelCell: {
                label: 'Brennstoffzelle',
            },
            orcPowerPlant: {
                label: 'ORC-Anlage',
            },
            emergencyGenerator: {
                label: 'Notstromaggregat > 100 ms',
            },
            storage: {
                label: 'Speicher',
            },
            stirlingEngine: {
                label: 'Stirling-Motor',
            },
        },
    },
    totalPlantPerformance: {
        label:
            'Welche installierte Gesamtleistung hat die anzumeldende Anlage?',
        info:
            'PV: Modulleistung<br />\r\nSpeicher: Nennentladeleistung<br />\r\nAlle anderen: Generatorleistung<br />',
        options: {
            above300: {
                label: '> 300 kW',
            },
            below300: {
                label: '<span style="font-weight: 200;">≤</span> 300 kW',
            },
        },
    },
    requestType: {
        label: 'Antragsart',
        options: {
            requestWithoutPlanning: {
                label: 'Anfrage ohne Planungsreife',
            },
            requestWithPlanning: {
                label: 'Anfrage mit Planungsreife',
            },
        },
    },
    requestWithPlanningInfo: {
        text:
            '<p>Die Planungsreife kann &uuml;ber vorhabensbezogene Dokumente nachgewiesen werden, weitere Informationen zu m&ouml;glichen Nachweisen finden Sie <a rel="noopener noreferrer" href="https://www.ewe-netz.de/einspeiser/strom/ihr-netzanschluss/reservierungsverfahren" target="_blank" title="Öffnet sich in einem neuen Browsertab.">hier</a>.<br />\n<br />\nBitte beachten Sie, dass wir f&uuml;r neue gro&szlig;e Graustromspeicherprojekte zurzeit keine neuen Netzverkn&uuml;pfungspunkte reservieren k&ouml;nnen. Weitere Informationen finden Sie <a rel="noopener noreferrer" href="https://www.ewe-netz.de/einspeiser/strom/ihr-netzanschluss/grossspeicher" target="_blank" title="Öffnet sich in einem neuen Browsertab.">hier</a>.<br />\n<br />\n<strong>Wichtiger Hinweis:</strong> Aufgrund begrenzter Netzkapazit&auml;ten im vorgelagerten Netz der Avacon Netz GmbH kann es bei Einspeisevorhaben zu Einschr&auml;nkungen beim Netzanschluss kommen. Nach den uns vorliegenden Informationen k&ouml;nnen erforderliche Netzausbauma&szlig;nahmen voraussichtlich zehn Jahre oder l&auml;nger in Anspruch nehmen.<br />\n<br />\nBitte beachten Sie au&szlig;erdem, dass bei Repowering-Vorhaben die bestehende Einspeiseleistung nicht automatisch als im Netz reservierte Leistung ber&uuml;cksichtigt wird. Die verf&uuml;gbare Netzkapazit&auml;t sowie die Anschlussm&ouml;glichkeiten werden f&uuml;r jedes Vorhaben auf Grundlage der aktuellen Netzsituation individuell gepr&uuml;ft.</p>',
    },
    requestWithoutPlanningInfo: {
        text:
            '<ul>\n    <li>\n    Es ist kein Nachweis der Planungsreife erforderlich&nbsp;</li>\n    <li>\n    Im Ergebnis wird ein zum Zeitpunkt der Pr&uuml;fung m&ouml;glicher Verkn&uuml;pfungspunkt und Kostenvoranschlag f&uuml;r die Herstellung des Netzanschlusses ermittelt (Tagesaussage)&nbsp;</li>\n    <li>\n    Die Entfernung zur n&auml;chstgelegenen Netzinfrastruktur k&ouml;nnen Sie ohne Antragsstellung in unserer <a rel="noopener noreferrer" href="https://online.netzauskunft.ewe-netz.de/" target="_blank">Online Auskunft</a> einsehen&nbsp;</li>\n</ul>\n<p>\n<strong>Wichtiger Hinweis:</strong> Aufgrund begrenzter Netzkapazit&auml;ten im vorgelagerten Netz der Avacon Netz GmbH kann es bei Einspeisevorhaben zu Einschr&auml;nkungen beim Netzanschluss kommen. Nach den uns vorliegenden Informationen k&ouml;nnen erforderliche Netzausbauma&szlig;nahmen voraussichtlich zehn Jahre oder l&auml;nger in Anspruch nehmen.\n<br />\n<br />\nBitte beachten Sie au&szlig;erdem, dass bei Repowering-Vorhaben die bestehende Einspeiseleistung nicht automatisch als im Netz reservierte Leistung ber&uuml;cksichtigt wird. Die verf&uuml;gbare Netzkapazit&auml;t sowie die Anschlussm&ouml;glichkeiten werden f&uuml;r jedes Vorhaben auf Grundlage der aktuellen Netzsituation individuell gepr&uuml;ft.\n</p>',
    },
    emergencyGeneratorOperatingMode: {
        label:
            'Bitte w&auml;hlen Sie die passenden Betriebsmodi f&uuml;r Ihr Notstromaggregat aus:',
        summaryLabel: 'Betriebsmodi Ihres Notstromaggregats',
        options: {
            testOperation: {
                label:
                    'Probebetrieb nach DIN 6280-13 bzw. VDE 0100-560 (VDE 0100 560)',
            },
            referenceTipCover: {
                label: 'Bezugsspitzenabdeckung',
            },
            controlEnergyMarket: {
                label: 'Teilnahme am Regelenergiemarkt',
            },
            other: {
                label: 'Sonstiges',
            },
        },
    },
    specifiedEmergencyGeneratorOperatingMode: {
        label: 'Bitte spezifizieren Sie den Betriebsmodus:',
        summaryLabel: 'Erg&auml;nzung Betriebsmodus',
        placeholder: 'Betriebsmodus',
    },
    plugInGeneratingPlant: {
        label:
            'Bei der geplanten Anlage handelt es sich um eine steckerfertige Erzeugungsanlage',
        summaryLabel: 'Steckerfertige Erzeugungsanlage',
        info:
            'Der Anschluss muss &uuml;ber eine spezielle Energiesteckdose (z.B. nach VDE V 0628-1) erfolgen. Die Scheinleistung darf nur &le; 600 VA je Anschlussnutzeranlage betragen.<br />\r\n<img alt="Scheinleistung" src="https://local.deaapi.ewe-netz.de/-/media/dea/bilder/formular/scheinleistung.png?la=de-de&amp;h=160&amp;w=315&amp;cb=4026F994&amp;hash=4A7EB57630D1A18DACBAEE99628B7C67" style="height: 160px; width: 315px;" />',
    },
    proceedWithFullRegistrationForEEGCompensation: {
        label:
            'Ich möchte mit der vollständigen Anmeldung bei EWE NETZ fortfahren, um eine EEG-Vergütung zu erhalten. Mir ist bewusst, dass ich dadurch zusätzliche Angaben und Erklärungen zur Ermittlung des Vergütungssatzes bereitstellen muss und eine Meldung der Inbetriebsetzung erforderlich ist.',
        summaryLabel: 'Vollständige Anmeldung für EEG Vergütung',
    },
    bidirectionalMeter: {
        label:
            'Ein Zweirichtungsz&auml;hler am zentralen Z&auml;hlerplatz ist vorhanden',
        summaryLabel: 'Zweirichtungsz&auml;hler',
        info:
            '<p>I.d.R. steht auf dem Z&auml;hler "Zweirichtungsz&auml;hler". Der Z&auml;hler hat 2 Ableseregister 1.8.0 / A+ = Energiebezug und 2.8.0 / A- = Energielieferung. N&auml;here Erl&auml;uterungen finden Sie auch unter <a rel="noopener noreferrer" rel="noopener noreferrer" href="https://www.ewe-netz.de/privatkunden/strom/smart-meter/zaehleranleitungen" target="_blank" title="Zähleranleitungen">Z&auml;hleranleitungen</a>.</p>\r\n<p><img height="855" alt="Zweirichtungszähler Pfeile" width="964" src="https://local.deaapi.ewe-netz.de/-/media/dea/bilder/formular/erzeugungsart/zweirichtungszaehler-pfeile.png?la=de-de&amp;cb=7F1A28B5&amp;hash=462B0A82A6C0B73C82B675E26B29121B" /></p>',
    },
    bidirectionalMeterInfo: {
        text:
            'Ein Zweirichtungsz&auml;hler ist notwendig. Ein evtl. notwendiger Z&auml;hlertausch erfolgt im Regelfall kostenlos durch ihren Messstellenbetreiber / Netzbetreiber, daf&uuml;r muss der Z&auml;hlerplatz mindestens f&uuml;r Drehstrom vorbereitet sein. (gepr&uuml;ft durch Elektroinstallateur)<br />\r\n<strong>Hinweis</strong>: Ein R&uuml;ckw&auml;rtslaufen des Z&auml;hlers stellt einen Versto&szlig; gegen das Steuerrecht dar und f&auml;llt unter Steuerhinterziehung bzw. Steuerverk&uuml;rzung.',
    },
    consumption: {
        label: '1.8.0 / A+ Verbrauch',
        summaryLabel: '1.8.0 / A+ Verbrauch',
        placeholder: '12345',
        unit: ',x kWh',
        info:
            'Das Anzeigeregister wechselt alle 15sek zwischen Verbrauch A+ / 1.8.0 und Einspeisung A- / 2.8.0.',
    },
    infeed: {
        label: '2.8.0 / A- Einspeisung',
        summaryLabel: '2.8.0 / A- Einspeisung',
        placeholder: '12345',
        unit: ',x kWh',
        info:
            'Das Anzeigeregister wechselt alle 15sek zwischen Verbrauch A+ / 1.8.0 und Einspeisung A- / 2.8.0.',
    },
    readingDate: {
        label: 'Datum der Ablesung',
        summaryLabel: 'Datum der Ablesung',
        placeholder: 'Ablesung',
    },
    plugInGeneratingPlantInfo: {
        text:
            '<p><span style="text-decoration: underline;"><strong>Besondere Hinweise zum Anschluss von steckerfertigen Erzeugungsanlagen mit einer Scheinleistung &le; 600 VA</strong></span></p>\r\n<br />\r\n<p><strong>ALLGEMEIN:</strong></p>\r\n<p>Falls Sie Hilfe benötigen oder Fragen zu dieser Anmeldung haben, finden Sie eine Klickanleitung sowie Antworten auf häufige Fragen auf unserer <a rel="noopener noreferrer" rel="noopener noreferrer" href="https://www.ewe-netz.de/einspeiser/strom/ihr-netzanschluss" class="external-link" target="_blank" title="Homepage">Homepage</a>.</p>\r\n<br />\r\n<p><strong>ANSCHLUSSART:</strong></p>\r\n<p>Die Anlage muss &uuml;ber eine Energiesteckvorrichtung nach DIN VDE V 0628-1 angeschlossen werden. Die Montage der Energiesteckdose muss durch einen Elektrofachbetrieb erfolgen. Die Inbetriebsetzung einer Anlage an einer bereits vorhandenen Energiesteckvorrichtung nach DIN VDE V 0628-1 kann dann durch den Betreiber jederzeit selbst erfolgen.</p>\r\n<br />\r\n<p><strong>VERBINDUNG ZUR STROMVERTEILUNG:</strong></p>\r\n<p>Die steckerfertige Erzeugungsanlage kann entweder singul&auml;r an einen eigenen Einspeisestromkreis angeschlossen werden,<br />\r\nODER<br />\r\nan einen Endstromkreis zusammen mit anderen Verbrauchern nach DIN VDE V 0100-551-1.</p>\r\n<p>Damit Sie Ihre Anlage sicher betreiben k&ouml;nnen ist in diesem Fall eine Fehlerstrom-Schutzeinrichtung (RCD) zwingend vorgeschrieben. Sie muss alle aktiven Leiter incl. Neutralleiter unterbrechen. Die Ausl&ouml;seschwelle- und die Ausl&ouml;sezeit m&uuml;ssen eingehalten werden. (gepr&uuml;ft durch Elektroinstallateur).</p>\r\n<p>Die Summe aus der Dimensionierung der Schutzeinrichtung und der Leistung der steckerfertige Erzeugungsanlage d&uuml;rfen die zul&auml;ssige Leitungsbelastung nicht &uuml;bersteigen, ggf. wird ein Sicherungstausch notwendig. (gepr&uuml;ft durch Elektroinstallateur).</p>\r\n<p>Die Anforderungen an die Leitungsdimensionierung m&uuml;ssen erf&uuml;llt sein. (gepr&uuml;ft durch Elektroinstallateur).</p>\r\n<p>Die Anlage muss &uuml;ber einen integrierten Netz- und Anlagenschutz (NA-Schutz) verf&uuml;gen. Die steckerfertige Erzeugungsanlage muss den anerkannten Regeln der Technik entsprechen. Hierzu erhalten Sie von dem Hersteller eine Konformit&auml;tsbest&auml;tigung &uuml;ber die Einhaltung der VDE AR N 4105. Erzeugungsanlagen ohne Konformit&auml;tsbest&auml;tigung d&uuml;rfen in Deutschland nicht betrieben werden.</p>\r\n<br />\r\n<p><strong>ANMELDUNG BUNDESNETZAGENTUR:</strong></p>\r\n<p>Die steckerfertige Erzeugungsanlage muss auch beim Marktstammdatenregister der Bundesnetzagentur angemeldet werden.&nbsp;<a rel="noopener noreferrer" rel="noopener noreferrer" href="https://www.marktstammdatenregister.de/MaStR" class="external-link" target="_blank" title="Marktstammdatenregister">https://www.marktstammdatenregister.de/MaStR</a></p>\r\n<br />\r\n<p><strong>SONSTIGES:</strong></p>\r\n<p>Die Montage der steckerfertige Erzeugungsanlage bedarf der Zustimmung des Geb&auml;udeeigent&uuml;mers, insbesondere unter Beachtung von statischen Anforderungen an die betroffenen Geb&auml;udeteile. (Zustimmung durch Eigent&uuml;mer / Hausverwaltung).</p>\r\n<p>Ihr Elektroinstallateur ber&auml;t Sie gern zu Fragen der sicheren Montage und des sicheren Betriebes der Anlage.</p>\r\n<br />\r\n<p><strong>INBETRIEBNAHME:</strong></p>\r\n<p>Die Inbetriebnahme Ihrer Erzeugungsanlage darf erst nach Installation eines Zweirichtungsz&auml;hlers erfolgen, sofern nicht vorhanden. Bitte teilen Sie uns die Inbetriebnahme mit dem ausgef&uuml;llten und unterschriebenen Inbetriebsetzungsprotokoll mit. Das Inbetriebsetzungsprotokoll erhalten Sie mit der Einspeisezusage nach Abschluss des Anmeldevorganges per E-Mail.</p>',
    },
    simplifiedRegistrationProcessNotice: {
        text:
            'Wir vereinfachen ihren Anmeldeprozess. Ab sofort müssen Sie ihr Balkonkraftwerk nur noch im Markstammdatenregister registrieren. Eine Anmeldung bei EWE NETZ ist nur noch erforderlich, wenn Sie eine EEG Vergütung erhalten wollen.',
        link: {
            text: 'Zur Registrierung im<br>Marktstammdatenregister',
            url: 'https://www.marktstammdatenregister.de/MaStR',
            target: '_blank',
        },
    },
    simplifiedProcedureHint: {
        text:
            'Bitte beachten Sie, dass das vereinfachte Verfahren für steckerfertige Erzeugungsanlagen nur angewendet werden kann, wenn Sie <strong><u>keine weiteren steckerfertigen Erzeugungsanlagen</u> an dieser Anschlussnutzeranlage (elektrische Anlage hinter ihrem Zähler) betreiben</strong>.',
    },
    plantStructureType: {
        label: 'Um was f&uuml;r eine Anlage handelt es sich?',
        info:
            'Ein Geb&auml;ude im Sinne des EEG ist jede selbstst&auml;ndig benutzbare, &uuml;berdeckte bauliche Anlage, die von Menschen betreten werden kann und vorrangig dazu bestimmt ist, dem Schutz von Menschen, Tieren oder Sachen zu dienen.',
        options: {
            building: {
                label: 'Gebäude',
            },
            noiseBarrier: {
                label: 'Lärmschutzwand',
            },
            openSpacePlant: {
                label: 'Freiflächenanlage',
            },
        },
    },
};
